import { getClient } from "foundation-client";

export type StatsItem = {
  art_id: number;
  is_trial: boolean;
  read_at: string;
  percent: number;
  scroll_events: number;
  statistics_received: "online" | "offline";
  symbols_count: number;
  chapter_statistics: { chapter_index: number }[];
};

export type PostStatsInput = {
  statistics: StatsItem[];
};

export async function postTextStats(input: PostStatsInput) {
  const client = getClient();
  const res = await client.POST("/api/statistics/arts/text", {
    body: input,
  });
  return res;
}
